import React, { FC, useState } from 'react'
import TableCustom, { TableCustomProps } from '../../../components/table/table'
import ButtonUI from '../../../components/button/buttons';
import StatusLabel from '../../../components/utils/StatusLabel';
import { formatToMexicanPesos } from '../../../components/utils/format';
import { PaymentIcon } from 'react-svg-credit-card-payment-icons';
import TableMaterial from '../../../components/tableMaterial/tableMaterial';

interface DataProps {
    data: any
}

export const TableWithdrawalModal: FC<DataProps> = (props) => {
    //   const [selectedTransaction, setSelectTransaction] = useState<null>(null);

    //   const [openModal, setOpenModal] = useState(false);

    //   const handleOpenModal = (transaction: any) => {
    //     setOpenModal(true);
    //     setSelectTransaction(transaction);
    //     // setOpenModal(true);
    //   };

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);


    const transformDataToTable = (
        transactions: any[]
    ): TableCustomProps["rows"] => {


        return transactions.map((transaction) => ({

            name: transaction.full_name,
            company: (
                <PaymentIcon
                    type={transaction.card_brand}
                    format="flatRounded"
                    width={36}
                />
            ),
            activity: transaction.status_description,
            email: transaction.email,
            amount: formatToMexicanPesos(transaction.amount),
            comision: transaction?.comission ? formatToMexicanPesos(transaction?.comission?.api_commission?.commission) : formatToMexicanPesos(transaction?.amount_with_comision),
            //country: transaction.currency,
            date: new Date(transaction?.created_at).toLocaleDateString("es-MX", {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZone: "America/Mexico_City",
            }),
            status: (<StatusLabel value={transaction.status} />),

            //   info: (
            //     <div>
            //       <ButtonUI
            //         //icon={<HelpIcon />}
            //         variant="text"
            //         onClick={() => handleOpenModal(transaction)}
            //       />
            //     </div>
            //   ),
        }));
    };

    const dataTable: any = {
        columns: [
            { id: "name", label: "Nombre" },
            { id: "company", label: "Banco" },
            { id: 'cardNumber', label: 'Numero de tarjeta' },
            { id: "activity", label: "Respuesta de banco" },
            { id: "email", label: "Correo" },
            { id: "amount", label: "Pago" },
            { id: "comision", label: "Comision" },
            //{ id: "country", label: "Moneda" },
            { id: "date", label: "Fecha" },
            { id: "status", label: "Estado" },
            //{ id: "info", label: "Info" },
        ],
        rows: transformDataToTable(props?.data.transactions_id || []),
    };

    return (
        <div>
            <TableMaterial
                isSearch={false}
                columns={dataTable.columns}
                rows={dataTable?.rows || []}
                totalRows={40}
                setRowsPerPage={setRowsPerPage}
                rowsPerPage={rowsPerPage}
                setPage={setPage}
                page={page}
                hideFooterPagination={true}
            />
        </div>
    )
}
